// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from './common/Button';
import { AssessmentTag } from '@its-svp/svp-common-ui';
import formatter from '../utils/formattingUtils';
import CloneDSAButton from './account/CloneDSAButton';
import ConvertDSAButton from './account/ConvertToCustomerDSAButton';
import ParentDSALink from './account/ParentDSALink';
import InlineDSATitleInput from './InlineDSATitleInput';
import { isInternalUser } from '../utils/assessmentUtils';
// css
import '../styles/components/AccountInformation.scss';


class AccountInformation extends Component {
  constructor(props) {
    super(props);

    this.handleCloneDSA = this.handleCloneDSA.bind(this);
    this.handleConvertDSA = this.handleConvertDSA.bind(this);
    this.handleUpdateDSA = this.handleUpdateDSA.bind(this);
    this.handleConvertCustomer = this.handleConvertCustomer.bind(this);
  }

  handleCloneDSA(isTest) {
    const { dsa, onCloneDSA } = this.props;
    onCloneDSA(dsa.dsa.id, isTest);
  }

  handleConvertDSA(isTest) {
    const { dsa, onConvertDSA } = this.props;
    onConvertDSA(dsa.dsa.id, isTest);
  }

  handleConvertCustomer() {
    const { onConvertCustomerDSA, dsa } = this.props;
    if (dsa.dsa.is_test) {
      onConvertCustomerDSA();
    } else {
      this.props.generatePPTXAndDownload();
    }
  }

  handleUpdateDSA(stateUpdates) {
    const { dsa, onUpdateDSA } = this.props;
    onUpdateDSA(dsa.dsa.id, stateUpdates);
  }

  renderParentDSALink() {
    const { dsa } = this.props;

    if (dsa.dsa.parent) {
      return (
        <ParentDSALink dsa={dsa} />
      );
    }
  }

  render() {
    const { dsa, user } = this.props,
      updated_date = new Date(dsa.dsa.updatedAt),
      title = dsa.account.name.toUpperCase();
    let cloneDSAButton = null;
    let convertDSAButton = null;

    if (isInternalUser(user)) {
      cloneDSAButton = <CloneDSAButton tooltipPosition='left' onClick={this.handleCloneDSA} />;
      convertDSAButton = <ConvertDSAButton dsa={dsa.dsa} onClick={this.handleConvertDSA} />;
    }

    return (
      <div className='account-information'>
        <div className='row'>
          <div className='col-xs-6'>
            {dsa.dsa.is_test && <div className='svp-common-ui tags'><AssessmentTag /></div>}
            <h6 className='account-title'>{title}</h6>
            <h4 className='dsa-title'>
              <InlineDSATitleInput
                dsa={dsa.dsa}
                onChange={this.handleUpdateDSA}
              />
            </h4>
            <div className='last-updated'>Last Updated: {formatter.formatNiceDate(updated_date)}</div>
            {this.renderParentDSALink()}
          </div>
          <div className='col-xs-6 buttons-right'>
            {dsa.dsa.is_test &&
              <div className='test-buttons'>
                {convertDSAButton}
                <Button
                  label='Generate PPT'
                  loading={this.props.pptx && this.props.pptx.generating}
                  loadingLabel='Generating...'
                  onClick={this.handleConvertCustomer}
                />
              </div>
            }
            {!dsa.dsa.is_test &&
              <div className='customer-buttons'>
                <Button
                  label='Generate PPT'
                  loading={this.props.pptx && this.props.pptx.generating}
                  loadingLabel='Generating...'
                  onClick={this.handleConvertCustomer}
                  primary
                />
                {cloneDSAButton}
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

AccountInformation.propTypes = {
  dsa: PropTypes.object,
  pptx: PropTypes.object,
  onConvertCustomerDSA: PropTypes.func,
  onCloneDSA: PropTypes.func.isRequired,
  onConvertDSA: PropTypes.func,
  onUpdateDSA: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  account: PropTypes.object,
  generatePPTXAndDownload: PropTypes.func
};

export default AccountInformation;



// WEBPACK FOOTER //
// ./src/components/AccountInformation.js